'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _reactModal = require('react-modal');

var _reactModal2 = _interopRequireDefault(_reactModal);

var _executionEnvironment = require('../../util/execution-environment');

var _modalLocal = require('./modal.local.css');

var _modalLocal2 = _interopRequireDefault(_modalLocal);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var ModalContent = function (_React$Component) {
  _inherits(ModalContent, _React$Component);

  function ModalContent() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ModalContent);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ModalContent.__proto__ || Object.getPrototypeOf(ModalContent)).call.apply(_ref, [this].concat(args))), _this), _this.handleDocumentKeydown = function (ev) {
      if (_this.props.closeOnEsc && ev.keyCode === 27) {
        _this.props.closeModal();
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ModalContent, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (_executionEnvironment.canUseDOM) {
        document.addEventListener('keydown', this.handleDocumentKeydown);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (_executionEnvironment.canUseDOM) {
        document.removeEventListener('keydown', this.handleDocumentKeydown);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          children = _props.children,
          size = _props.size,
          closeOnBackdropClick = _props.closeOnBackdropClick,
          closeModal = _props.closeModal,
          isOpen = _props.isOpen,
          name = _props.name,
          overlayClassName = _props.overlayClassName,
          theme = _props.theme;
      return _react2.default.createElement(_reactModal2.default, {
        appElement: document && (document.getElementById('react-root') || document.getElementById('root') || document.body),
        isOpen: isOpen,
        contentLabel: name,
        onRequestClose: closeModal,
        shouldCloseOnOverlayClick: closeOnBackdropClick,
        overlayClassName: (0, _classnames2.default)(_modalLocal2.default.overlay, overlayClassName, _modalLocal2.default[theme]),
        className: (0, _classnames2.default)(_modalLocal2.default.content, _modalLocal2.default['size--' + size], className)
      }, children);
    }
  }]);

  return ModalContent;
}(_react2.default.Component);

ModalContent.defaultProps = {
  closeOnBackdropClick: true,
  closeButton: true,
  closeOnEsc: true,
  size: 'large',
  title: null,
  theme: 'light'
};
ModalContent.propTypes = {
  closeModal: _propTypes2.default.func.isRequired,
  closeOnBackdropClick: _propTypes2.default.bool,
  children: _propTypes2.default.node.isRequired,
  closeOnEsc: _propTypes2.default.bool,
  isOpen: _propTypes2.default.bool.isRequired,
  name: _propTypes2.default.string.isRequired,
  className: _propTypes2.default.string,
  overlayClassName: _propTypes2.default.string,
  size: _propTypes2.default.oneOf(['auto', 'small', 'large']),
  theme: _propTypes2.default.oneOf(['dark', 'light'])
};
exports.default = ModalContent;